<template>
  <div class="mutual-induction-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>ε₂ = -M (dI₁/dt) | 变压器基础$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Primary Coil -->
          <g transform="translate(100, 120)">
             <rect x="-20" y="-50" width="40" height="100" fill="none" stroke="#cd7f32" stroke-width="3" />
             <path v-for="i in 6" :key="'p'+i" :d="`M -20,${-40+i*14} L 20,${-40+i*14}`" stroke="#cd7f32" stroke-width="1.5" />
             <text x="-15" y="-60" fill="#cd7f32" font-size="8">初级 L1</text>
             
             <!-- Magnetic Field Lines (Changing) -->
             <g v-if="acOn">
                <ellipse v-for="i in 3" :key="'f'+i" :rx="20 + i*40" :ry="10 + i*20" fill="none" 
                         stroke="rgba(255, 215, 0, 0.3)" stroke-dasharray="4,2">
                   <animate attributeName="stroke-width" values="1;3;1" dur="1s" repeatCount="indefinite" />
                </ellipse>
             </g>
          </g>

          <!-- Secondary Coil -->
          <g transform="translate(250, 120)">
             <rect x="-20" y="-50" width="40" height="100" fill="none" stroke="#888" stroke-width="3" />
             <path v-for="i in 6" :key="'s'+i" :d="`M -20,${-40+i*14} L 20,${-40+i*14}`" stroke="#888" stroke-width="1.5" />
             <text x="-15" y="-60" fill="#888" font-size="8">次级 L2</text>
             
             <!-- Galvanometer on Secondary -->
             <circle cx="80" cy="0" r="15" fill="#222" stroke="#888" />
             <line x1="80" y1="0" :x2="80+needleX" :y2="needleY" stroke="#ff4757" stroke-width="2" />
          </g>

          <!-- Label -->
          <text x="140" y="50" fill="#888" font-size="10">耦合磁通 φ₁₂</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>状态: {{ acOn ? '交变电流激励中' : '静态' }}</label>
              <div class="value" :style="{color: acOn ? '#ffd700' : '#888'}">感知电压 U₂: {{ inducedVoltage.toFixed(2) }} V</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
           <div class="row items-center">
              <label>初级电源</label>
              <el-switch v-model="acOn" active-color="#ffd700"></el-switch>
           </div>
           <div class="row items-center mt-2">
              <label>电源频率</label>
              <el-slider v-model="freq" :min="1" :max="50" size="mini"></el-slider>
           </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>互感现象是指当一个线圈中的电流发生变化时，它产生的穿过邻近线圈的磁通量也随之发生变化，从而在第二个线圈中感应出电动势。感应电动势的大小取决于**互感系数 M** 以及第一个线圈电流的变化率。这是所有**变压器、无线充电器以及非接触感应器**工作的物理基础。没有直接接触，能量却能通过磁场跨越空间，体现了场的作用本质。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MutualInductionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      acOn: true,
      freq: 10,
      t: 0,
      timer: null
    }
  },
  computed: {
    inducedVoltage() {
       if (!this.acOn) return 0;
       // V2 = M * d(sin(wt))/dt = M * w * cos(wt)
       return Math.abs(Math.cos(this.t * 0.1 * this.freq) * (this.freq / 5));
    },
    needleX() {
       let val = this.inducedVoltage * 10;
       return Math.sin(this.t * 0.1 * this.freq) * val;
    },
    needleY() {
       return -Math.sqrt(225 - this.needleX*this.needleX);
    }
  },
  methods: {
    animate() {
       this.t += 1;
       this.timer = requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.mutual-induction-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(205, 127, 50, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
